import { Card } from '@mui/material';
import { cardShadow } from '../../constants/uiTokens';

/**
 * Card padronizado — aplica visualmente o padrão de cards do projeto.
 *
 * G6 — VALIDAÇÃO VISUAL PENDENTE (afeta TODA a app):
 *   Default agora é FLAT (borda fina + sombra sutil da designer), SEM accent-left.
 *   O accent-left só aparece se `accentColor` for passado explicitamente (opt-in).
 *   Rollback: voltar `accentColor = 'primary.main'` no default e remover boxShadow.
 *
 * @param {boolean}  noAccent     - Força remover a border-left mesmo com accentColor (default: false)
 * @param {string}   accentColor  - Cor (theme path) da accent border. Default null = sem accent (flat).
 * @param {boolean}  fillHeight   - height: 100% + flex column (default: true)
 * @param {ReactNode} children
 * @param {Object}   sx           - sx extra mesclado sobre os estilos padrão
 * @param {*}        props        - demais props repassadas ao MUI Card
 *
 * @example
 * // Card flat padrão (novo default)
 * <StandardCard><CardContent>...</CardContent></StandardCard>
 *
 * // Card com accent de marca (opt-in)
 * <StandardCard accentColor="success.main">...</StandardCard>
 */
export default function StandardCard({
  noAccent = false,
  accentColor = null,
  fillHeight = true,
  children,
  sx,
  ...props
}) {
  const showAccent = !!accentColor && !noAccent;
  const baseSx = {
    border: '1px solid',
    borderColor: 'divider',
    boxShadow: cardShadow, // G6 — sombra sutil "flat" da designer
    ...(fillHeight ? { height: '100%', display: 'flex', flexDirection: 'column' } : {}),
    ...(showAccent ? {
      borderLeft: '3px solid',
      borderLeftColor: accentColor,
    } : {}),
  };

  return (
    <Card elevation={0} sx={[baseSx, sx]} {...props}>
      {children}
    </Card>
  );
}
